/**
 * Phase 3b §1 — `/portal/signin` disambiguation landing.
 *
 * When a visitor hits `/portal` with no session, `Portal.jsx` now routes
 * here instead of straight to /team/login, so employees know where they
 * belong. Two doors: "I'm an employer" and "I'm an employee".
 */
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { track } from "../lib/analytics";
import "./Team.css";

export default function PortalSignin() {
    const { t } = useTranslation();
    useEffect(() => {
        track("portal_signin_view", {});
        document.title = t("auth.disambig.title");
    }, [t]);

    return (
        <section className="lg-section team-track" data-testid="portal-signin-page">
            <div className="team-panel">
                <div className="section-label mono">{t("auth.disambig.label")}</div>
                <h1>{t("auth.disambig.h1")}</h1>
                <p className="team-sub">{t("auth.disambig.sub")}</p>

                <div className="portal-signin-doors">
                    <Link
                        to="/employee/login"
                        className="portal-signin-door"
                        data-testid="portal-signin-employee"
                        onClick={() => track("portal_signin_door.employee", {})}
                    >
                        <div className="portal-signin-door-label mono">
                            {t("auth.disambig.employeeLabel")}
                        </div>
                        <div className="portal-signin-door-title">
                            {t("auth.disambig.employeeTitle")}
                        </div>
                        <div className="portal-signin-door-cta">
                            {t("auth.disambig.employeeCta")} →
                        </div>
                    </Link>

                    <Link
                        to="/team/login"
                        className="portal-signin-door"
                        data-testid="portal-signin-employer"
                        onClick={() => track("portal_signin_door.employer", {})}
                    >
                        <div className="portal-signin-door-label mono">
                            {t("auth.disambig.employerLabel")}
                        </div>
                        <div className="portal-signin-door-title">
                            {t("auth.disambig.employerTitle")}
                        </div>
                        <div className="portal-signin-door-cta">
                            {t("auth.disambig.employerCta")} →
                        </div>
                    </Link>
                </div>
            </div>
        </section>
    );
}
